import React from 'react';
    import SafeIcon from './common/SafeIcon';

    const EnhancedStatCard = ({ title, items, icon }) => {
      return (
        <div className="bg-bitcoin-card border border-white/5 p-6 rounded-2xl backdrop-blur-sm hover:border-bitcoin/30 transition-colors duration-300">
          <div className="flex items-start justify-between mb-4">
            <span className="text-gray-400 text-sm font-medium">{title}</span>
            <div className="p-2 bg-white/5 rounded-lg text-bitcoin">
              <SafeIcon icon={icon} className="w-5 h-5" />
            </div>
          </div>
          <div className="flex flex-col gap-3">
            {items.map((item, index) => (
              <div key={index} className="flex justify-between items-center">
                <span className="text-sm text-gray-300">{item.label}</span>
                <div className="flex flex-col items-end">
                  <span className="text-base font-bold text-white font-mono">{item.value}</span>
                  {item.subValue && (
                    <span className="text-xs text-gray-500 font-mono">{item.subValue}</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      );
    };

    export default EnhancedStatCard;